export enum CaptchaType {
    RecaptchaV3 = "RecaptchaV3", // 1
    DNTCaptcha = "DNTCaptcha", // 2

    RecaptchaV2 = "RecaptchaV2", // 3
}
